module.exports = __webpack_public_path__ + "static/agro-4a3447e00c010c215c8cc51c3c24e404.png";